import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type {
  FinanceDataQualityFilters,
  FinanceDataQualityResponse,
} from "./data-quality-types";

export async function fetchFinanceDataQuality(
  range: FinanceDateRangeValue,
  page: number,
  search: string,
  filters: FinanceDataQualityFilters,
): Promise<FinanceDataQualityResponse> {
  const response = await axiosApiInstance.get<FinanceDataQualityResponse>(
    "/finance/data-quality",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        search: search || undefined,
        areas: filters.areas.length ? filters.areas : undefined,
        severities: filters.severities.length ? filters.severities : undefined,
        reports: filters.reports.length ? filters.reports : undefined,
        issue_types: filters.issueTypes.length ? filters.issueTypes : undefined,
        class_ids: filters.classIds.length ? filters.classIds : undefined,
        category_ids: filters.categoryIds.length
          ? filters.categoryIds
          : undefined,
        product_ids: filters.productIds.length ? filters.productIds : undefined,
        customer_ids: filters.customerIds.length
          ? filters.customerIds
          : undefined,
        supplier_ids: filters.supplierIds.length
          ? filters.supplierIds
          : undefined,
        currency_ids: filters.currencyIds.length
          ? filters.currencyIds
          : undefined,
        scopes: filters.scopes.length ? filters.scopes : undefined,
      },
    },
  );

  return response.data;
}
